import * as React from 'react';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import "./product.sass"
import Product from './Product';
import { UserContext } from 'src/hooks/context/userInfo';
import { Alert, Empty, Skeleton, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;

export interface AmountProduct {
  idCurrency: string;
  amount: number | null;
  idOwnProduct: string;
  id: string;
}
export interface TraductionProduct {
  idLanguage: string;
  title: string;
  description: string;
  instruction: string;
  idOwnProduct: string;
  id: string;
}

export interface ProductProps {
  id: string;
  image: string;
  increment: number;
  isActive: boolean;
  productsTargets: number[] | any[];
  amountOriginals: AmountProduct[];
  amountDiscounts: AmountProduct[];
  traductions: TraductionProduct[];
  imageName: string;
  base64Image: string;
  imageContent: number;
  link?: string;
}

export default function Products({ setAvailableMoney, availableMoney }: { setAvailableMoney: (value: any) => void; availableMoney?: any }) {
  const { t } = useTranslation(["reward"]);

  const restApiClient = React.useContext(RestApiClientContext);
  const user = React.useContext(UserContext);
  const [height, setHeigth] = React.useState("auto")
  const [products, setProducts] = React.useState<ProductProps[]>([]);
  const [loading, setLoading] = React.useState(false)
  React.useEffect(() => {
    if (products.length === 0) return;

    const observer = new ResizeObserver(() => {
      let maxHeight = 0;
      products.forEach(product => {
        const el = document.getElementById(product.id);
        if (el) {
          maxHeight = Math.max(maxHeight, el.offsetHeight);
        }
      });
      if (maxHeight > 0) {
        setHeigth(maxHeight + "px");
      }
    });

    products.forEach(product => {
      const el = document.getElementById(product.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [products]);

  React.useEffect(() => {
    setLoading(true)
    restApiClient.getProducts().then((response) => {
      response.forEach(product => {
        product.traductions = product.traductions.filter(t => t.idLanguage === user.GetLanguageUser());
        product.amountDiscounts = product.amountDiscounts.filter(t => t.idCurrency === user.GetCurrency());
        product.amountOriginals = product.amountOriginals.filter(t => t.idCurrency === user.GetCurrency());
      })
      setLoading(false)
      setProducts(response.filter(products => products.isActive));
    })


  }, []);
  return products.length > 0 ? <div style={{ backgroundColor: 'white', padding: '20px', marginTop: 20 }}>


    <Title level={4}>{t("title-products")}</Title>
    <Alert icon type='info' message={"Disfruta de descuentos exclusivos en serivicios de la cadena. El coste de estos servicios se descontará de tu saldo total disponible"} />
    <div style={{ gridTemplateColumns: products.length <= 1 ? 'repeat(auto-fill, minmax(280px, 300px))' : null }} className='products-container' >
      <Skeleton active loading={loading}>

        {products.length > 0 ? products.map((product, index) => <Product availableMoney={availableMoney} setAvailableMoney={setAvailableMoney} key={product.id} product={product} id={product?.id || index + ""} height={height} t={t} />) : <Empty />}

      </Skeleton>

    </div>
  </div> : null
}